import { Link, usePage } from '@inertiajs/react'

import { Container, Title, Text, Anchor, Group, Stack } from '@mantine/core'
import StationLists from '../_StationLists'
import Seo from '../../_Seo'
import { breadcrumbList } from '../../_structuredData'
import { useI18n } from '../../_i18n'
import { useLocalePath } from '../../_localePath'

export default function CityPage({ city }) {
  const { t } = useI18n()
  const localePath = useLocalePath()
  const c = city || {}
  const country = c.country || {}
  const state = c.state
  const tide = c.tide_stations || []
  const current = c.current_stations || []
  const { site_url: siteUrl = '' } = usePage().props

  const place = [c.name, state && state.name, country.name].filter(Boolean).join(', ')
  const crumbs = [
    { name: country.name, path: localePath(`/countries/${country.permalink}`) },
    ...(state ? [{ name: state.name, path: localePath(`/states/${state.permalink}`) }] : []),
    // id-qualified: city permalinks collide across states, so the canonical URL
    // is "<id>-<permalink>" (see City#url / Web::LocationsController#resolve_city).
    { name: c.name, path: localePath(`/cities/${c.id}-${c.permalink}`) },
  ]

  return (
    <>
      <Seo
        title={t('location_title', { name: c.name })}
        description={t('city_seo_description', { place, name: c.name })}
        jsonLd={breadcrumbList(siteUrl, crumbs)}
      />
      <Container size="md" py="xl">
        <Group gap="xs" mb="xs">
          {country.permalink && (
            <Anchor
              component={Link}
              href={localePath(`/countries/${country.permalink}`)}
              c="dimmed"
              size="sm"
            >
              {country.name}
            </Anchor>
          )}
          {state && state.permalink && (
            <>
              <span>›</span>
              <Anchor
                component={Link}
                href={localePath(`/states/${state.permalink}`)}
                c="dimmed"
                size="sm"
              >
                {state.name}
              </Anchor>
            </>
          )}
        </Group>
        <Title order={1} mb="lg">
          {c.name}
        </Title>
        <Stack gap="md">
          <StationLists tideStations={tide} currentStations={current} />
          {!tide.length && !current.length && (
            <Text c="dimmed">{t('no_stations_found_location')}</Text>
          )}
        </Stack>
      </Container>
    </>
  )
}
